import React, { useCallback, useState } from "react";
import ReactTooltip from "react-tooltip";
import { insertTags } from "../../../utils/url";
import tpFulfilledIndicator from "../../../static/images/tpFulfilledIndicator.svg";
import TPNoRatingIndicator from "../../../components/svgs/TPNoRatingIndicator";
import tpNotFulfilledIndicator from "../../../static/images/tpNotFulfilledIndicator.svg";
import AuditResultsList from "../AuditResultsList";
import BrandRuleResultRenderer from "../BrandRuleResultRenderer";
import StatusInfoIcon from "../../../components/svgs/StatusInfoIcon";
import { makeShade, makeOppositeShade } from "../../../utils/colorService";
import "./styles.scss";

const BrandRuleResult = ({
  t,
  index,
  item,
  marketGoalComment,
  checkedTrueMarketGoals,
  checkedFalseMarketGoals,
  markegGoalAudits,
  profileId,
  showTitle = false,
  lblBrandRules = null,
  isMilestoneView = false,
  client,
  hasLongNames = false,
}) => {
  const [expandState, setExpandState] = useState(false);
  const getToolTip = useCallback(
    () =>
      item.description && (
        <span className="form-marketGoal-additional-info">
          <span data-tip data-for={item.name}>
            <StatusInfoIcon color={makeOppositeShade(client?.primaryTextColor)} />
          </span>
          <ReactTooltip id={item.name} className="tooltip" effect="solid" type="light" place="right">
            {item.description}
          </ReactTooltip>
        </span>
      ),
    [item], //eslint-disable-line react-hooks/exhaustive-deps
  );

  const showDescriptionInRow =
    (window.innerWidth > 1100 && marketGoalComment && !isMilestoneView) ||
    (!!markegGoalAudits.length && !isMilestoneView);
  return (
    <BrandRuleResultRenderer index={index} isMilestoneView={isMilestoneView} expandState={expandState}>
      <div className={markegGoalAudits.length ? "form-marketGoal with-audit" : "form-marketGoal"}>
        <div
          className={`marketGoal-info-block ${showDescriptionInRow && "description-in-row"} ${
            hasLongNames && "long-names"
          }`}
        >
          <div className="form-marketGoal-text-block">
            {showTitle && (
              <div className="brand-title">{t("dailyQuest.ruleTitle", { lblBrandRules: lblBrandRules })}</div>
            )}
            <div className="form-marketGoal-text">
              {item.name}
              {getToolTip()}
            </div>
            {showDescriptionInRow && (
              <div className="form-marketGoal-description in-row-description">
                <pre
                  className="display-comment-textarea"
                  dangerouslySetInnerHTML={{ __html: insertTags(marketGoalComment) }}
                ></pre>
              </div>
            )}
          </div>
          <div className="form-marketGoal-check">
            {checkedTrueMarketGoals.indexOf(item._id) !== -1 && <img src={tpFulfilledIndicator} alt="" />}
            {checkedFalseMarketGoals.indexOf(item._id) !== -1 && <img src={tpNotFulfilledIndicator} alt="" />}
            {checkedTrueMarketGoals.indexOf(item._id) === -1 && checkedFalseMarketGoals.indexOf(item._id) === -1 && (
              <TPNoRatingIndicator color={makeShade(client?.primaryTextColor)} />
            )}
          </div>
        </div>
        {marketGoalComment && ((window.innerWidth <= 1100 && !markegGoalAudits.length) || isMilestoneView) && (
          <div className="text-block">
            <div className="form-marketGoal-description">
              <pre
                className="display-comment-textarea"
                dangerouslySetInnerHTML={{ __html: insertTags(marketGoalComment) }}
              ></pre>
            </div>
          </div>
        )}
        {!!markegGoalAudits.length && (
          <AuditResultsList
            t={t}
            markegGoalAudits={markegGoalAudits}
            profileId={profileId}
            setExpandState={setExpandState}
          />
        )}
      </div>
    </BrandRuleResultRenderer>
  );
};

export default BrandRuleResult;
